import { SerializePayload } from 'app/area/search-filters/types';
import { filterId } from './constants';
import { ExperienceTransferSearchModel } from './types-store';
import { serializeCodes } from 'app/area/search-filters/serialize/serialize';
import { ComplexValue } from 'app/types-shared';
import { queryFilters } from 'app/area/experience-transfer/constants';

export const serializeQuery = (query: string, value: ComplexValue<number | string>[]) => {

  const searchInSubscriberGroup = (value || []).some(v => v.value === queryFilters.subscriberGroup);
  const searchInCriteria = (value || []).some(v => v.value === queryFilters.criteria);

  return query && query.trim().length &&
    (searchInSubscriberGroup || searchInCriteria)
    ? {
      [filterId.query]: {
        text: query.trim(),
        ...(!!value && {
          searchInSubscriberGroup,
          searchInCriteria
        })
      }
    }
    : {};
};

export const serialize = (dataToSerialize: SerializePayload): ExperienceTransferSearchModel => {

  const { query, queryValues, formValues, menuValues, filters, filterValidation } = dataToSerialize;

  return {
    ...serializeQuery(query, queryValues),
    ...serializeCodes(formValues, menuValues, filters, filterValidation)
  };
};
